import { endpoints } from "../Api/configs";
import apiClient from "./apiClient";

export const fetchStreamOrganizerChats = async (eventId, accessToken) => {
  return apiClient(endpoints.streamOrganizer.streamChats, {
    method: "POST",
    body: JSON.stringify({ eventId, accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchStreamOrganizerDetails = async (eventId, accessToken) => {
  return apiClient(endpoints.streamOrganizer.streamDetails, {
    method: "POST",
    body: JSON.stringify({ eventId, accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchStreamOrganizerGifts = async (eventId, accessToken) => {
  return apiClient(endpoints.streamOrganizer.streamGifts, {
    method: "POST",
    body: JSON.stringify({ eventId, accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchStreamOrganizerLikes = async (eventId, accessToken) => {
  return apiClient(endpoints.streamOrganizer.streamLikes, {
    method: "POST",
    body: JSON.stringify({ eventId, accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// Stream Participant Functions
export const fetchStreamParticipantChats = async (eventId, accessToken) => {
  return apiClient(endpoints.streamParticipant.streamChats, {
    method: "POST",
    body: JSON.stringify({ eventId, accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchStreamParticipantDetails = async (eventId, accessToken) => {
  return apiClient(endpoints.streamParticipant.streamDetails, {
    method: "POST",
    body: JSON.stringify({ eventId, accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchStreamParticipantGifts = async (eventId, accessToken) => {
  return apiClient(endpoints.streamParticipant.streamGifts, {
    method: "POST",
    body: JSON.stringify({ eventId, accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchStreamParticipantLikes = async (eventId, accessToken) => {
  return apiClient(endpoints.streamParticipant.streamLikes, {
    method: "POST",
    body: JSON.stringify({ eventId, accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchStreamDetailsYoutube = async (eventId, accessToken) => {
  return apiClient(endpoints.stream.streamDetailsYoutube, {
    method: "POST",
    body: JSON.stringify({ eventId, accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchUserConnectionStatus = async (accessToken) => {
  return apiClient(endpoints.stream.userConnectionStatus, {
    method: "POST",
    body: JSON.stringify({ accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const DisconnectUser = async (accessToken: string, type: string) => {
  return apiClient(endpoints.stream.userDisconnect, {
    method: "POST",
    body: JSON.stringify({ accessToken, type }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const storeYouTubeToken = async (
  youtubeAuthCode,
  accessToken,
  redirectUri
) => {
  return apiClient(endpoints.stream.storeToken, {
    method: "POST",
    body: JSON.stringify({ youtubeAuthCode, accessToken, redirectUri }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const storeTwitchToken = async (
  twitchAuthCode,
  AccessToken,
  redirectUri
) => {
  return apiClient(endpoints.streamTwitch.storeToken, {
    method: "POST",
    body: JSON.stringify({ twitchAuthCode, AccessToken, redirectUri }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createStream = async (eventId, accessToken) => {
  return apiClient(endpoints.stream.createStream, {
    method: "POST",
    body: JSON.stringify({ eventId, accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createTwitchStream = async (eventId, AccessToken) => {
  return apiClient(endpoints.streamTwitch.createStream, {
    method: "POST",
    body: JSON.stringify({ eventId, AccessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const gpLiveAndUpdateBroadcastId = async (eventId, AccessToken) => {
  return apiClient(endpoints.streamTwitch.goLiveAndUpdateStream, {
    method: "POST",
    body: JSON.stringify({ eventId, AccessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateStreamDetailsAfterStreamComplete = async (
  eventId,
  AccessToken
) => {
  return apiClient(endpoints.streamTwitch.updateStreamOnStopStream, {
    method: "POST",
    body: JSON.stringify({ eventId, AccessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchUserDetails = async (accessToken) => {
  return apiClient(endpoints.stream.userDetails, {
    method: "POST",
    body: JSON.stringify({ accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchUserYouTubeStreamKeyDetails = async (accessToken) => {
  return apiClient(endpoints.auth.youtube, {
    method: "POST",
    body: JSON.stringify({ accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchUserTwitchStreamKeyDetails = async (AccessToken) => {
  return apiClient(endpoints.auth.twitch, {
    method: "POST",
    body: JSON.stringify({ AccessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateStreamStatusOnStartAndStopRecording = async (
  accessToken: string,
  eventId: string,
  status: string
) => {
  return apiClient(endpoints.events.updateStreamStatusOnStartAndStopRecording, {
    method: "POST",
    body: JSON.stringify({ accessToken, eventId, status }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateAudienceOnStreamPaused = async (
  accessToken: string,
  eventId: string,
  status: string
) => {
  return apiClient(endpoints.events.updateAudienceOnStreamPaused, {
    method: "POST",
    body: JSON.stringify({ accessToken, eventId }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const handleStreamParticipationReward = async (
  accessToken: string,
  eventId: string
) => {
  return apiClient(endpoints.stream.handleStreamParticipationReward, {
    method: "POST",
    body: JSON.stringify({ accessToken, eventId }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const UpdateYoutubeEmbeddingSettingsForUser = async (
  eventId,
  accessToken
) => {
  return apiClient(endpoints.stream.UpdateYouTubeEmbeddingSettings, {
    method: "POST",
    body: JSON.stringify({ eventId, accessToken }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchLiveViewers = async (eventId: string, accessToken: string) => {
  const queryParams = new URLSearchParams({
    eventId,
    accessToken,
  }).toString();

  return apiClient(`${endpoints.activity.liveUsers}?${queryParams}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
